import { HierarchyReadDto } from "functions/api/hierarchy/HierarchyReadDto";
import { getReplacementSaveBlockers } from "./getReplacementSaveBlockers";
import { ISaveBlocker } from "./interface";

/**
 * Derives the domain replacement save blockers from a hierarchy.
 *
 * @param hierarchy - The hierarchy whose domain replacements are validated, or null when none is loaded.
 * @returns The blockers for the hierarchy's domain replacements (empty when there is no hierarchy).
 */
export const getDomainReplacementsSaveBlockers = (
  hierarchy: HierarchyReadDto | null,
): Set<ISaveBlocker> =>
  getReplacementSaveBlockers(
    hierarchy?.domainReplacements ?? [],
    (a, b) => a.domain === b.domain && a.oldText === b.oldText,
    "domainReplacements",
  );
